// extracted by mini-css-extract-plugin
module.exports = {"title":"Diff_title__yW7_o","body":"Diff_body__10Dix","oldValue":"Diff_oldValue__3sOKe","currentValue":"Diff_currentValue__1qU9J"};